import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const scrollToSection = id => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };
  return <header className="w-full bg-white py-4 px-6 md:px-12 shadow-sm fixed top-0 z-50" data-id="element-88">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-89">
        <div className="flex items-center" data-id="element-90">
          <a href="https://neurotoned.com" target="_blank" rel="noopener noreferrer" data-id="element-91">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j4ckz63hJh5X49fhFHKCGw/ChatGPT_Image_Jul_1__2025__05_41_29_PM-removebg-preview.png" alt="Neurotoned Logo" className="h-12" data-id="element-92" />
          </a>
          <a href="https://neurotoned.com" target="_blank" rel="noopener noreferrer" className="ml-2 text-xl font-semibold text-teal-800" data-id="element-93">
            Neurotoned
          </a>
        </div>
        <nav className="hidden md:flex space-x-8" data-id="element-94">
          <a href="#benefits" className="text-teal-700 hover:text-teal-900" onClick={e => {
          e.preventDefault();
          scrollToSection('benefits');
        }} data-id="element-95">
            Benefits
          </a>
          <a href="#programs" className="text-teal-700 hover:text-teal-900" onClick={e => {
          e.preventDefault();
          scrollToSection('programs');
        }} data-id="element-96">
            Programs
          </a>
          <a href="#pricing" className="text-teal-700 hover:text-teal-900" onClick={e => {
          e.preventDefault();
          scrollToSection('pricing');
        }} data-id="element-97">
            Pricing
          </a>
          <a href="#faq" className="text-teal-700 hover:text-teal-900" onClick={e => {
          e.preventDefault();
          scrollToSection('faq');
        }} data-id="element-98">
            FAQ
          </a>
        </nav>
        <div className="md:hidden" data-id="element-99">
          <button className="text-teal-700" onClick={toggleMenu} data-id="element-100">
            {isMenuOpen ? <XIcon size={24} data-id="element-101" /> : <MenuIcon size={24} data-id="element-102" />}
          </button>
        </div>
        <div className="hidden md:block" data-id="element-103">
          <button className="bg-teal-700 hover:bg-teal-800 text-white py-2 px-6 rounded-md font-medium transition duration-300" onClick={() => scrollToSection('pricing')} data-id="element-104">
            Get Started
          </button>
        </div>
      </div>
      {/* Mobile menu dropdown */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-md py-4 px-6 z-50 border-t border-gray-100" data-id="element-105">
          <nav className="flex flex-col space-y-4" data-id="element-106">
            <a href="#benefits" className="text-teal-700 hover:text-teal-900 py-2" onClick={e => {
          e.preventDefault();
          scrollToSection('benefits');
        }} data-id="element-107">
              Benefits
            </a>
            <a href="#programs" className="text-teal-700 hover:text-teal-900 py-2" onClick={e => {
          e.preventDefault();
          scrollToSection('programs');
        }} data-id="element-108">
              Programs
            </a>
            <a href="#pricing" className="text-teal-700 hover:text-teal-900 py-2" onClick={e => {
          e.preventDefault();
          scrollToSection('pricing');
        }} data-id="element-109">
              Pricing
            </a>
            <a href="#faq" className="text-teal-700 hover:text-teal-900 py-2" onClick={e => {
          e.preventDefault();
          scrollToSection('faq');
        }} data-id="element-110">
              FAQ
            </a>
            <button className="bg-teal-700 hover:bg-teal-800 text-white py-2 px-6 rounded-md font-medium transition duration-300 mt-2 text-left" onClick={() => scrollToSection('pricing')} data-id="element-111">
              Get Started
            </button>
          </nav>
        </div>}
    </header>;
};
export default Header;